import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import SlideMenu from 'components/presenter/menu/SlideMenu'
import { List, ListItem } from '@material-ui/core'
import { getPathFromLocation } from 'libs/router/routeHelper'
import { useTranslation, Link, useI18next } from 'gatsby-plugin-react-i18next'
import AppIcon from 'assets/svg/app_icon.inline.svg'
import * as styles from './main.module.css'

const menu = [ {
  path: '/jetso/',
  name: 'mainMenu.jetsoManagement',
}, {
  path: '/company-profile/',
  name: 'mainMenu.companyProfile',
}, {
  path: '/shop-locations/',
  name: 'mainMenu.shopLocations',
}]

const MainMenu = ({ className = '', location, open = false, onToggle}) => {
  const [ state, setState ] = useState({
    currentIndex: 0,
  })
  const { t } = useTranslation()
  const { navigate } = useI18next()

  function getPageIndex() {
    const path = getPathFromLocation(location)
    return menu.findIndex(menuItem => menuItem.path === path)
  }

  useEffect(() => {
    const pI = getPageIndex()
    setState({
      currentIndex: pI,
    })
  }, [ location ])

  return (
    <SlideMenu
      className={cn(className, styles.slideMenu)}
      onToggle={onToggle}
      open={open}
    >
      <div>
        <AppIcon className={cn(styles.appIcon)} onClick={() => navigate('/jetso/')} />
        <List component="nav" disablePadding>
          {menu.map((menuItem, index) => (
            <ListItem 
              button
              disableGutters
              selected={index === state.currentIndex}
              // eslint-disable-next-line react/no-array-index-key
              key={`items-${index}`}
              classes={{
                selected: cn(styles.menuTxtSelectedBgColor)
              }}
            >
              <Link 
                className={cn(styles.menuItem)} 
                to={menuItem.path}>{t(menuItem.name)}</Link>
            </ListItem>
          ))}
        </List>
      </div>
    </SlideMenu>
  )
}

export default MainMenu